__turbopack_context__.v({
  "drawer-button": "reportForm-module-scss-module__lpFOiq__drawer-button",
  "drawer-button-container": "reportForm-module-scss-module__lpFOiq__drawer-button-container",
  "drawer-button-container-opened": "reportForm-module-scss-module__lpFOiq__drawer-button-container-opened",
  "drawer-button-opened": "reportForm-module-scss-module__lpFOiq__drawer-button-opened",
  "drawer-content": "reportForm-module-scss-module__lpFOiq__drawer-content",
  "drawer-content-button": "reportForm-module-scss-module__lpFOiq__drawer-content-button",
  "drawer-content-button-container": "reportForm-module-scss-module__lpFOiq__drawer-content-button-container",
  "drawer-content-button-disabled": "reportForm-module-scss-module__lpFOiq__drawer-content-button-disabled",
  "drawer-content-closed": "reportForm-module-scss-module__lpFOiq__drawer-content-closed",
  "drawer-content-container": "reportForm-module-scss-module__lpFOiq__drawer-content-container",
  "drawer-content-container-opened": "reportForm-module-scss-module__lpFOiq__drawer-content-container-opened",
  "drawer-content-form": "reportForm-module-scss-module__lpFOiq__drawer-content-form",
  "drawer-content-opened": "reportForm-module-scss-module__lpFOiq__drawer-content-opened",
  "drawer-content-scrollable": "reportForm-module-scss-module__lpFOiq__drawer-content-scrollable",
  "drawer-content-title": "reportForm-module-scss-module__lpFOiq__drawer-content-title",
  "drawer-overlay": "reportForm-module-scss-module__lpFOiq__drawer-overlay",
  "fade-in-ux308hk": "reportForm-module-scss-module__lpFOiq__fade-in-ux308hk",
});
